import React from 'react';
import styles from './TermosDeUso.module.scss';
import { Helmet } from 'react-helmet';

const TermosUso = () => {
  return (
    <>
      <Helmet>
        <title>Termos de Uso - Alcance Tecnologia</title>
        <meta name="description" content="Termos de uso do site e serviços da Alcance Tecnologia." />
      </Helmet>
      
      <div className={styles.container}>
        <div className={styles.header}>
          <h1>Termos de Uso</h1>
          <p>Última atualização: 15 de Novembro de 2023</p>
        </div>

        <div className={styles.content}>
          <section className={styles.section}>
            <h2>1. Aceitação dos Termos</h2>
            <p>
              Ao acessar e utilizar o site da Alcance Tecnologia, localizado em 
              https://www.alcancetecnologia.com.br, você concorda em cumprir e estar vinculado 
              a estes Termos de Uso. Se você não concordar com qualquer parte destes termos, 
              não poderá utilizar nossos serviços.
            </p>
          </section>

          <section className={styles.section}>
            <h2>2. Modificações dos Termos</h2>
            <p>
              Reservamo-nos o direito de modificar estes Termos de Uso a qualquer momento. 
              Todas as alterações entrarão em vigor imediatamente após a publicação no site. 
              O uso continuado do site após quaisquer modificações constitui sua aceitação 
              dos novos termos. Recomendamos que você revise periodicamente esta página 
              para estar ciente de quaisquer alterações.
            </p>
          </section>

          <section className={styles.section}>
            <h2>3. Serviços Oferecidos</h2>
            <p>
              A Alcance Tecnologia oferece serviços de desenvolvimento de software, 
              consultoria em tecnologia, soluções personalizadas e outros serviços 
              relacionados à área de tecnologia da informação, conforme descrito 
              em nosso site.
            </p>
            <p>
              Nos reservamos o direito de modificar, suspender ou descontinuar qualquer 
              aspecto dos serviços a qualquer momento, incluindo a disponibilidade de 
              qualquer recurso, database ou conteúdo.
            </p>
          </section>

          <section className={styles.section}>
            <h2>4. Cadastro do Usuário</h2>
            <p>
              Algumas funcionalidades do site podem exigir cadastro ou registro. Ao se 
              cadastrar, você concorda em:
            </p>
            <ul>
              <li>Fornecer informações verdadeiras, exatas, atuais e completas</li>
              <li>Manter e atualizar suas informações para mantê-las verdadeiras, exatas, atuais e completas</li>
              <li>Ser responsável pela confidencialidade de sua senha e por todas as atividades que ocorrerem em sua conta</li>
              <li>Notificar-nos imediatamente sobre qualquer uso não autorizado de sua conta ou qualquer outra violação de segurança</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>5. Propriedade Intelectual</h2>
            <p>
              Todo o conteúdo do site, incluindo textos, gráficos, logos, ícones, imagens, 
              clipes de áudio, downloads digitais, compilações de dados e software, é 
              propriedade da Alcance Tecnologia ou de seus fornecedores de conteúdo e 
              está protegido pelas leis de propriedade intelectual brasileiras e 
              internacionais.
            </p>
            <p>
              Você concorda em não reproduzir, duplicar, copiar, vender, revender ou 
              explorar comercialmente qualquer parte do site, uso do site ou acesso 
              ao site sem autorização expressa por escrito de nossa parte.
            </p>
          </section>

          <section className={styles.section}>
            <h2>6. Conduta do Usuário</h2>
            <p>
              Ao utilizar nosso site, você concorda em não:
            </p>
            <ul>
              <li>Violar qualquer lei, regulamento ou regra aplicável</li>
              <li>Infringir direitos de propriedade intelectual de terceiros</li>
              <li>Enviar conteúdo ilegal, difamatório, abusivo, obsceno, ameaçador ou ofensivo</li>
              <li>Distribuir vírus ou outros technologies maliciosas</li>
              <li>Coletar informações de outros usuários sem consentimento</li>
              <li>Utilizar o site para fins fraudulentos ou ilegais</li>
              <li>Interferir ou interromper a operação do site ou servidores</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>7. Links para Sites de Terceiros</h2>
            <p>
              Nosso site pode conter links para sites de terceiros. Esses links são 
              fornecidos apenas para conveniência. Não temos controle sobre o conteúdo 
              desses sites e não nos responsabilizamos por eles ou por qualquer perda 
              ou dano que possa surgir do uso desses links.
            </p>
            <p>
              A inclusão de qualquer link não implica necessariamente endosso ou 
              aprovação dos views neles expressos.
            </p>
          </section>

          <section className={styles.section}>
            <h2>8. Limitação de Responsabilidade</h2>
            <p>
              Em nenhum caso a Alcance Tecnologia, seus diretores, funcionários ou 
              parceiros serão responsáveis por quaisquer danos diretos, indiretos, 
              incidentais, especiais, consequenciais ou punitivos, incluindo, mas 
              não limitado a, perda de lucros, dados, uso, goodwill ou outras 
              perdas intangíveis, resultantes de:
            </p>
            <ul>
              <li>Seu acesso ou uso ou incapacidade de acesso ou uso do site</li>
              <li>Qualquer conduta ou conteúdo de terceiros no site</li>
              <li>Qualquer conteúdo obtido do site</li>
              <li>Acesso não autorizado, uso ou alteração de suas transmissões ou conteúdo</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>9. Indenização</h2>
            <p>
              Você concorda em defender, indenizar e isentar a Alcance Tecnologia, 
              suas afiliadas, licenciantes e funcionários de qualquer reclamação, 
              demanda, perda, responsabilidade, dano, custo ou despesa (incluindo 
              honorários advocatícios razoáveis) resultantes de ou relacionados ao:
            </p>
            <ul>
              <li>Seu uso do site</li>
              <li>Violação destes Termos de Uso</li>
              <li>Violacao de qualquer direito de terceiros</li>
              <li>Qualquer conteúdo que você enviar ou transmitir através do site</li>
            </ul>
          </section>

          <section className={styles.section}>
            <h2>10. Rescisão</h2>
            <p>
              Podemos terminar ou suspender seu acesso imediatamente, sem aviso prévio 
              ou responsabilidade, por qualquer motivo, incluindo, sem limitação, se 
              você violar os Termos de Uso.
            </p>
            <p>
              Após a rescisão, seu direito de usar o site cessará imediatamente. 
              Todas as disposições dos Termos que por sua natureza devem sobreviver 
              à rescisão sobreviverão à rescisão.
            </p>
          </section>

          <section className={styles.section}>
            <h2>11. Lei Aplicável</h2>
            <p>
              Estes Termos serão regidos e interpretados de acordo com as leis da 
              República Federativa do Brasil, sem consideração a seus conflitos de 
              disposições legais.
            </p>
            <p>
              Qualquer disputa decorrente ou relacionada a estes Termos será submetida 
              aos tribunais competentes do distrito de São Miguel do Oeste, Santa Catarina.
            </p>
          </section>

          <section className={styles.section}>
            <h2>12. Disposições Gerais</h2>
            <p>
              Estes Termos constituem o acordo completo entre você e a Alcance Tecnologia 
              em relação ao uso do site, substituindo todos os acordos anteriores ou 
              contemporâneos.
            </p>
            <p>
              Se qualquer provision destes Termos for considerada inválida ou inexequível 
              por um tribunal competente, as demais disposições permanecerão em pleno 
              vigor e efeito.
            </p>
            <p>
              Nossa falência em exercer ou fazer valer qualquer direito ou provision 
              destes Termos não constituirá renúncia a tal direito ou provision.
            </p>
          </section>

          <section className={styles.section}>
            <h2>13. Contato</h2>
            <p>
              Se você tiver dúvidas sobre estes Termos de Uso, entre em contato conosco:
            </p>
            <div className={styles.contactInfo}>
              <p><strong>Alcance Tecnologia</strong></p>
              <p>E-mail: legal@alcancetecnologia.com.br</p>
              <p>Telefone: +55 (049) 3621-1469</p>
              <p>Endereço: São Miguel do Oeste, SC Bairro São Jorge, 1727 Rua Florianópolis</p>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default TermosUso;